import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { DefaultLayout } from '../../layout/theme-customizer';

const id = window.location.pathname.split('/').pop();
const defaultLayout = Object.keys(DefaultLayout);
const layout = id ? id : defaultLayout;

class Crear extends React.Component {
    constructor(props) {
        super(props);
        // INICIALIZAR STATE DENTRO DEL CONSTRUCTOR
        this.state = {
            nombre: '',
            estado: '',
            icon: 'Folder',
            orden_mp: '',
            errores: []
        };
    }

    cambioValor = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            errores: this.state.errores.filter(error => !error.includes(name)) // Elimina errores del campo modificado
        });
    }

    verificarError = (elemento) => {
        return this.state.errores.includes(elemento);
    }

    enviarDatos = (e) => {
        e.preventDefault();
        const { nombre, estado, icon, orden_mp } = this.state;
        
        // INICIALIZAR CORRECTAMENTE EL ARRAY
        const errores = [];
        
        if (!nombre || nombre.trim() === '') { 
            errores.push("error_nombre"); 
        }
        if (estado === '' || estado === null || estado === undefined) { 
            errores.push("error_estado"); 
        }
        if (!icon || icon.trim() === '') { 
            errores.push("error_icon"); 
        }
        if (!orden_mp || orden_mp.trim() === '') { 
            errores.push("error_orden_mp"); 
        }
        
        this.setState({ errores: errores });
        
        if (errores.length > 0) {
            Swal.fire({
                icon: 'error',
                title: 'Campos incompletos',
                text: 'Por favor complete todos los campos requeridos'
            });
            return false;
        }
        
        const datosEnviar = {
            nombre: nombre.trim(),
            estado: estado,
            icon: icon,
            orden_mp: orden_mp.trim(),
        };
        
        authAxios.post("configuracion/registrar", datosEnviar)
            .then((datosRespuesta) => {
                // Asegúrate de verificar la propiedad correcta del response
                const esExitoso = datosRespuesta.data?.Status || datosRespuesta.data?.status || false;
                
                if (esExitoso) {
                    Swal.fire({
                        title: '¡Éxito!',
                        text: datosRespuesta.data.msj || 'Registro completado exitosamente',
                        icon: 'success',
                        confirmButtonText: 'Aceptar'
                    }).then(() => {
                        if (this.props.history) {
                            this.props.history.push("/configuracion/lista/Dubai");
                        } else {
                            window.location.href = "/configuracion/lista/Dubai";
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: datosRespuesta.data?.msj || 'Ocurrió un error al registrar',
                        icon: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                }
            })
            .catch((error) => {
                console.error('Error en la solicitud:', error);
                Swal.fire({
                    title: 'Error de conexión',
                    text: 'No se pudo conectar al servidor',
                    icon: 'error',
                    confirmButtonText: 'Aceptar'
                });
            });
    }

    componentDidMount() {
        // Si necesitas cargar datos iniciales
    }

    render() {
        const { nombre, estado, icon, orden_mp } = this.state;
        const iconOptions = [
            "Folder", "Home", "FolderPlus", "Cloud", "FileText", "Server",
            "Users", "ShoppingBag", "List", "Mail", "MessageCircle", "Monitor",
            "Clock", "Calendar", "CheckSquare", "Image", "Film", "Radio",
            "Map", "Edit", "Sunrise", "Activity", "Archive", "BarChart",
            "Book", "Briefcase"
        ];

        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE MENÚ</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="nombre">Nombre *</label>
                                                    <input 
                                                        style={{ textTransform: 'uppercase' }} 
                                                        className={`form-control form-control-sm ${this.verificarError("error_nombre") ? "is-invalid" : ""}`} 
                                                        type="text" 
                                                        name="nombre" 
                                                        id="nombre" 
                                                        value={nombre} 
                                                        placeholder="Escriba el nombre" 
                                                        onChange={this.cambioValor} 
                                                        autoComplete="off"
                                                    />
                                                    {this.verificarError("error_nombre") && (
                                                        <div className="invalid-feedback">Digite el nombre</div>
                                                    )}
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="estado">Estado *</label>
                                                    <select 
                                                        name="estado"
                                                        id="estado"
                                                        className={`form-select form-select-sm ${this.verificarError("error_estado") ? "is-invalid" : ""}`}
                                                        value={estado}
                                                        onChange={this.cambioValor}
                                                    >
                                                        <option value="">Seleccione el Estado</option>
                                                        <option value="0">Activo</option>
                                                        <option value="1">Inactivo</option>
                                                    </select>
                                                    {this.verificarError("error_estado") && (
                                                        <div className="invalid-feedback">Seleccione el estado</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="row mt-3">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="icon">Icono *</label>
                                                    <select 
                                                        name="icon"
                                                        id="icon"
                                                        className={`form-select form-select-sm ${this.verificarError("error_icon") ? "is-invalid" : ""}`}
                                                        value={icon}
                                                        onChange={this.cambioValor}
                                                    >
                                                        {iconOptions.map((iconName, index) => (
                                                            <option key={index} value={iconName}>
                                                                {iconName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {this.verificarError("error_icon") && (
                                                        <div className="invalid-feedback">Seleccione un icono</div>
                                                    )}
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="orden_mp">Orden en el menú *</label>
                                                    <input 
                                                        style={{ textTransform: 'uppercase' }} 
                                                        className={`form-control form-control-sm ${this.verificarError("error_orden_mp") ? "is-invalid" : ""}`} 
                                                        type="text" 
                                                        name="orden_mp" 
                                                        id="orden_mp" 
                                                        value={orden_mp} 
                                                        placeholder="Orden" 
                                                        onChange={this.cambioValor}
                                                        autoComplete="off"
                                                    />
                                                    {this.verificarError("error_orden_mp") && (
                                                        <div className="invalid-feedback">Digite el orden</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <hr />
                                    <div className='row mt-3'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm">
                                                    <FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Menú
                                                </button>&nbsp;&nbsp;
                                                <Link 
                                                    className="btn btn-danger btn-sm" 
                                                    to={`${process.env.PUBLIC_URL}/configuracion/lista/${layout}`}
                                                >
                                                    <FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="card-footer text-muted">
                <small>Los campos marcados con * son obligatorios</small>
              </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;